import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faEllipsisH, faVideo} from "@fortawesome/free-solid-svg-icons";
import RatingStars from "./RatingStars";
import ThreadPrefixes from "./ThreadPrefixes";
import React, {useContext} from "react";
import {AuthContext} from "../../context/authContext";
import ThreadActionItems from "../Thread/section/ThreadActionItems";
import PopupMenu from "./PopupMenu";
import { LazyLoadImage } from 'react-lazy-load-image-component';

const ThreadPortalItem = ({thread}) => {
	const {visitor} = useContext(AuthContext);

	return (
		<div className={`relative flex-1 thread-item-content border border-url ${thread.discussion_state === 'deleted' && 'grayscale'} rounded-lg md:border-2`}>
			{thread.has_videos && (
				<FontAwesomeIcon icon={faVideo} className="absolute top-2 left-2 text-2xl text-orange-400 z-20" />
			)}

			{thread.is_idol && (
				<div className="idol-icon absolute top-2 right-2 z-20" />
			)}

			{(!thread.discussion_open || thread.ft_temp_off) && (
				<div className="mask-offline absolute p-2 bg-gray-800 text-center text-2xl text-white font-bold top-[50%] left-0 right-0 -translate-y-[50%] z-20">
					TẠM NGHỈ
				</div>
			)}

			<div className="block relative bg-secondary w-full h-auto pt-[120%] rounded-t-lg overflow-hidden md:pt-[150%]">
				<a href={thread.view_url} title={thread.title}
				   className="absolute top-0 left-0 w-full h-full rounded-lg bg-gray-400 z-10">
					<img src={thread.thumbnail_url} className="w-full h-full object-cover" alt={thread.title}/>
				</a>

				{thread.can_edit && visitor && visitor.is_admin && (
					<div className="absolute bottom-2 left-2 z-20">
						<PopupMenu
							label={
								<div className="py-1 px-2 text-sm text-white bg-primary rounded-md inline-flex items-center">
									<FontAwesomeIcon icon={faEllipsisH} />
								</div>
							}>
							<div className="szh-menu-container-background">
								<ThreadActionItems thread={thread}/>
							</div>
						</PopupMenu>
					</div>
				)}

				<div className="absolute text-sm text-white font-semibold bottom-2 right-2 z-20">
					<p>{thread.username}</p>
					<p>{thread.post_date_meta}</p>
				</div>
			</div>

			<a href={thread.view_url} className="block thread-item-content w-full p-2 rounded-b-lg md:p-4">
				<ThreadPrefixes thread={thread} />

				{thread.price && (
					<div className="text-md text-white font-bold text-center mb-1 md:text-xl">
						{thread.price}K
					</div>
				)}

				<div
					className="w-full text-sm font-bold text-center text-url whitespace-nowrap overflow-hidden text-ellipsis mb-1">
					{thread.title}
				</div>

				{thread.is_promote && (
					<RatingStars score={thread.rating_score} />
				)}
			</a>
		</div>
	);
}

export default ThreadPortalItem;